module.exports = "/_next/static/images/ourPartnersLogo10-17df4f3cb61f9587438aadfcab42b326.webp";